if (!customElements.get('wavex-card-purchase')) {
  customElements.define('wavex-card-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('form');
      this.select = this.querySelector('select[name="id"]');
      this.controls = this.querySelector('fieldset');
      this.button = this.querySelector('[type="submit"]');
      this.status = this.querySelector('[role="status"]');
      this.error = this.querySelector('[role="alert"]');
      if (!this.form || !this.select || !this.button || !this.controls) return;
      this.initialized = true;
      this.card = this.closest('.card-wrapper, .wx-choice__card') || this;
      this.card.classList.add('wx-card-direct');
      this.card.querySelectorAll('[aria-labelledby]').forEach((element) => {
        const ids = element.getAttribute('aria-labelledby').split(/\s+/).filter((id) => !id.includes('Badge'));
        if (ids.length) element.setAttribute('aria-labelledby', ids.join(' '));
        else element.removeAttribute('aria-labelledby');
      });
      this.select.addEventListener('change', () => this.updateVariant(true));
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.updateVariant(false);
      this.controls.disabled = false;
      this.dataset.ready = 'true';
    }

    updateVariant(announce) {
      const option = this.select.selectedOptions[0];
      if (!option) {
        this.button.disabled = true;
        return;
      }
      const data = option.dataset;
      const available = data.available === 'true';
      const quantity = Math.max(1, Number.parseInt(data.quantity, 10) || 1);
      this.controls.querySelector('.wx-card-purchase__price').textContent = data.price;
      const compare = this.controls.querySelector('.wx-card-purchase__compare');
      compare.textContent = data.comparePrice || '';
      compare.hidden = !data.comparePrice;
      const unitPrice = this.querySelector('.wx-card-purchase__unit-price');
      unitPrice.textContent = data.unitPrice || '';
      unitPrice.hidden = !data.unitPrice;
      this.querySelector('span[data-sku]').textContent = data.sku || '';
      this.querySelector('[data-sku-wrap]').hidden = !data.sku;
      this.querySelector('[data-availability]').textContent = available ? this.dataset.inStockLabel : this.dataset.soldOutLabel;
      this.querySelector('[name="quantity"]').value = String(quantity);
      this.querySelector('[data-quantity-label]').textContent = String(quantity);
      this.querySelector('[data-quantity-note]').hidden = quantity === 1;
      this.querySelector('[data-price-each]').hidden = quantity === 1;
      this.button.disabled = !available || this.busy === true;
      this.querySelector('[data-button-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      this.button.setAttribute('aria-label', `${available ? this.dataset.addLabel : this.dataset.soldOutLabel}: ${this.dataset.productTitle}, ${data.label}`);
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart) this.button.setAttribute('aria-haspopup', 'dialog');
      else this.button.removeAttribute('aria-haspopup');
      this.updateImage(data);
      this.card.dataset.selectedVariantId = option.value;
      const productPath = new URL(this.dataset.productUrl, window.location.origin).pathname;
      this.card.querySelectorAll('a[href]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin && url.pathname === productPath) {
          url.searchParams.set('variant', option.value);
          link.href = url.toString();
        }
      });
      this.error.hidden = true;
      this.status.textContent = announce ? this.dataset.selectionTemplate
        .replace('[variant]', data.label)
        .replace('[price]', data.price)
        .replace('[availability]', available ? this.dataset.inStockLabel : this.dataset.soldOutLabel) : '';
    }

    updateImage(data) {
      const frame = this.card.querySelector('[data-card-image-frame]');
      if (!frame) return;
      let image = frame.querySelector('img');
      const fallback = frame.querySelector('[data-image-unavailable]');
      const clearImage = (reason) => {
        if (image) {
          image.hidden = true;
          image.removeAttribute('srcset');
          image.removeAttribute('src');
          image.alt = '';
        }
        if (fallback) fallback.hidden = false;
        frame.dataset.imageState = reason;
      };
      frame.dataset.imageMapping = data.imageMapping || (data.imageSrc ? 'assigned' : 'missing');
      if (!data.imageSrc) {
        clearImage('unavailable');
        return;
      }
      if (!image) {
        image = document.createElement('img');
        image.className = 'motion-reduce wx-card-variant-image';
        image.loading = 'lazy';
        image.width = 800;
        image.height = 800;
        image.sizes = '(min-width: 990px) 25vw, 50vw';
        frame.prepend(image);
      }
      // A failed URL must never leave a previous pack photograph on the card.
      image.onerror = () => clearImage('load-error');
      image.alt = data.imageAlt || this.dataset.productTitle;
      image.srcset = data.imageSrcset || '';
      image.src = data.imageSrc;
      image.hidden = false;
      if (fallback) fallback.hidden = true;
      frame.dataset.imageState = 'available';
    }

    publishCartEvent(type, payload) {
      if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS[type]) return;
      try { Promise.resolve(publish(PUB_SUB_EVENTS[type], payload)).catch(() => {}); } catch (_) {}
    }

    async submit(event) {
      event.preventDefault();
      const option = this.select.selectedOptions[0];
      if (this.busy || !option || this.button.disabled || option.dataset.available !== 'true') return;
      const formData = new FormData(this.form);
      const variantId = option.value;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sections = typeof cart?.getSectionsToRender === 'function' ? cart.getSectionsToRender().slice(0, 5) : [];
      if (sections.length) {
        formData.set('sections', sections.map((section) => section.id).join(','));
        formData.set('sections_url', window.location.pathname);
        cart.setActiveElement?.(this.button);
      }
      this.busy = true;
      this.controls.disabled = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[data-button-label]').textContent = this.dataset.addingLabel;
      this.querySelector('.wx-card-purchase__spinner').hidden = false;
      this.error.hidden = true;
      this.status.textContent = this.dataset.addingLabel;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      let confirmedAdded = false;
      const cartUrl = window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
      const cartAddUrl = window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
          signal: controller.signal,
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const failure = new Error(typeof result.description === 'string' ? result.description : this.dataset.requestError);
          failure.confirmedRejection = true;
          throw failure;
        }
        confirmedAdded = true;
        this.status.textContent = `${this.dataset.addedLabel}: ${option.dataset.label}.`;
        this.publishCartEvent('cartUpdate', { source: 'product-form', productVariantId: variantId, cartData: result });
        if (!sections.length || !sections.every((section) => typeof result.sections?.[section.id] === 'string') || typeof cart?.renderContents !== 'function') {
          window.location.assign(cartUrl);
          return;
        }
        cart.classList.remove('is-empty');
        cart.renderContents(result);
      } catch (error) {
        if (confirmedAdded) {
          window.location.assign(cartUrl);
          return;
        }
        const message = error.confirmedRejection ? error.message : this.dataset.networkError;
        this.querySelector('[data-error-text]').textContent = message;
        this.error.hidden = false;
        this.status.textContent = '';
        this.publishCartEvent('cartError', { source: 'product-form', productVariantId: variantId, errors: message, message });
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.controls.disabled = false;
        this.button.disabled = this.select.selectedOptions[0]?.dataset.available !== 'true';
        this.setAttribute('aria-busy', 'false');
        this.querySelector('.wx-card-purchase__spinner').hidden = true;
        this.querySelector('[data-button-label]').textContent = this.button.disabled ? this.dataset.soldOutLabel : this.dataset.addLabel;
      }
    }
  });
}
